import { ChartData, ChartOptions } from 'chart.js';
import { Line } from 'react-chartjs-2';

import '../register';

interface TrendSeries {
  label: string;
  color: string;
  /** `null` cria um gap na linha (mês sem OS avaliada). */
  data: (number | null)[];
}

interface TrendChartProps {
  labels: string[];
  series: TrendSeries[];
  height?: number;
  /** Sparkline: esconde legenda, eixos e pontos. */
  minimal?: boolean;
}

export function TrendChart({
  labels,
  series,
  height = 260,
  minimal = false,
}: TrendChartProps): JSX.Element {
  const data: ChartData<'line'> = {
    labels,
    datasets: series.map((serie) => ({
      label: serie.label,
      data: serie.data,
      borderColor: serie.color,
      backgroundColor: `${serie.color}22`,
      pointBackgroundColor: serie.color,
      borderWidth: 2,
      tension: 0.35,
      fill: minimal,
      pointRadius: minimal ? 0 : 3,
    })),
  };

  const options: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: 'index', intersect: false },
    plugins: {
      legend: {
        display: !minimal,
        position: 'bottom',
        labels: { usePointStyle: true },
      },
      tooltip: { enabled: !minimal },
    },
    scales: {
      y: { display: !minimal, beginAtZero: false, grid: { color: '#EEEEF2' } },
      x: { display: !minimal, grid: { display: false } },
    },
  };

  return (
    <div style={{ height }}>
      <Line data={data} options={options} />
    </div>
  );
}
